<div *ngIf="content?.cards?.length > 0">
  <eds-carousel-slider
    [preTitle]="content.preTitle"
    [titleLabel]="content.title"
    [textContent]="processedText"
    [linkContentUrl]="content.link.url"
    [linkContent]="content.link.displayText"
    [sliderItems]="cards"
    [prevPageText]="labels?.previous | translate"
    [nextPageText]="labels?.next | translate"
    [signInTooltip]="'common.locked-link-tooltip' | translate"
    [theme]="titleColorTheme"
  ></eds-carousel-slider>
</div>
